import React from "react";

export function Testimonials() {
  const testimonials = [
    {
      text: "Suite à l'annonce du mariage de ma sœur dans un pays voisin, j'ai décidé de laisser ma voiture chez PLR Park. Ravi d'avoir pu confier ma voiture dans un box individuel sans crainte. Dans la navette, nous avons parlé de ma passion pour l'automobile tout le trajet. Vous allez me revoir !",
      author: "JEAN-LUC",
    },
    {
      text: "J'étais déjà amateur de parking privé pour mes voyages récurrents. Mais PLR Park est et restera mon favori. Nous restons dans des prix plus qu'abordables, et j'apprécie particulièrement la compagnie singulière que m'offre la navette.",
      author: "NELSON",
    },
    {
      text: "Mon mari et moi-même passons déjà le cap de partir de l'aéroport de Beauvais/Tillé au lieu de CDG ou d'ORLY. N'étant pas rassurée d'y laisser la voiture à l'air libre, j'ai découvert PLR Park avec leurs box couverts. Une prestation de professionnels.",
      author: "MARIANNE SPIZONA",
    },
  ];

  return (
    <section className="py-20 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-4xl font-bold text-center text-white mb-16 relative">
          Les avis de nos clients
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-[#0A0A0A]/80 rounded-xl p-4 sm:p-6 border-2 border-[#FF7954]
                         transform hover:-translate-y-4 transition-all duration-300
                         hover:border-[#FCDEBE] h-auto sm:h-[400px] flex flex-col relative"
            >
              <div className="flex-grow flex flex-col">
                <span className="text-5xl sm:text-7xl text-[#FF7954]/20 font-serif absolute top-2 left-3 sm:left-4">
                  "
                </span>
                <p className="text-white text-sm sm:text-lg italic relative z-10 pt-6 sm:pt-8 pl-4 sm:pl-6 leading-relaxed">
                  {testimonial.text}
                </p>
              </div>
              <div className="text-[#FF7954] font-semibold text-right mt-3 sm:mt-4 text-sm sm:text-base">
                {testimonial.author}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
